import { Quotation } from "../models/quotations";

export function hasTwoHoursDifference(quotations: Quotation[]): boolean {

    quotations.forEach((quotation: Quotation) => {
        // Get the current timestamp in SECONDS
        const currentEpochSeconds: number = Math.floor(Date.now() / 1000);

        // Check if the current time has passed the expiration time
        return currentEpochSeconds >= quotation.expire_at;
    })

    return false;
}
